/**
 * 渲染类型的可用属性
 */
export enum RenderType {
  SVG = "0",
  JPEG = "1",
  BASE64 = "2",
}

export enum GenderType {
  UNSET = "0",
  MALE = "1",
  FEMAL = "2",
}

export enum LAYER_ID {
  BASE = "base",
  EAR = "ear",
  EAR_RING = "earRing",
  EYE_BROWS = "eyeBrows",
  EYES = "eyes",
  FACIAL_HAIR = "facialHair",
  GLASSES = "glasses",
  HAIR = "hair",
  HAT = "hat",
  MOUTH = "mouth",
  NOSE = "nose",
  SHIRT = "shirt",
  BACKGROUND = "background",
  MASK = "mask",
  HEADWEAR = "headwear",
}
